<template>
	<div class="component-container">
		<GameBackground></GameBackground>
		<!--Sub Routes to switch between emails and scenes-->
		<!--<transition name="custom" mode="out-in" appear>-->
			<router-view :key="$route.fullPath"></router-view>
		<!--</transition>-->
		<DeskItem></DeskItem>
		<TotalMoney></TotalMoney>
	</div>
</template>

<script>
import Button from '@/components/abstract/Button';
import GameBackground from '@/components/abstract/GameBackground';
import TotalMoney from '@/components/abstract/TotalMoney';
import DeskItem from '@/components/abstract/DeskItem';
import random from '@/mixins/random';
import { mapState } from 'vuex';

export default {
	name: 'Game',
	mixins: [random],
	data() {
		return {
			peopleNum: 0,
			returnerArray: [],
			allSpecialRequests: [],
			paydayPerson: null,
			returnerEmailAssigned: false,
		};
	},
	components: {
		Button,
		GameBackground,
		TotalMoney,
		DeskItem,
	},
	computed: {
		...mapState({
			game_config: state => state.config.data.game_config,
		}),
		peopleForRandoms() {
			// get people not assigned to specials, shuffle, then loop through and assign to randoms
			return this.shuffled(this.$store.getters.getPeopleForRandoms(false));
		},
	},
	methods: {
		setGameStructure() {
			// get and store the number of levels from WP
			const totalNumLevels = this.game_config.level_config.length;
			this.$store.commit('setTotalLevels', totalNumLevels);
			this.allSpecialRequests = JSON.parse(JSON.stringify(this.shuffled(this.$store.getters.getRequestsByType("Special"))));
			// for each level, call to create the Game array
			let randomLevelRequests = [];
			this.paydayPerson = undefined;
			for (let i = 0; i < totalNumLevels; i += 1) {
				// if level 1, only get randoms not assigned to be possible question 1 or 2 in the order
				if (i === 0) {
					randomLevelRequests = JSON.parse(JSON.stringify(this.$store.getters.getRequestsByTypeAndLevelAndOrder(i + 1, "Random", 0)));
				} else {
					randomLevelRequests = JSON.parse(JSON.stringify(this.$store.getters.getRequestsByTypeAndLevel(i + 1, "Random")));
				}
				const paydayRequest = JSON.parse(JSON.stringify(this.$store.getters.getRequestsByTypeAndLevel(i + 1, "Payday")));
				this.createGameArray(this.game_config.level_config[i].random_requests, randomLevelRequests, paydayRequest, this.game_config.level_config[i].special_requests, this.game_config.level_config[i].number_of_returners, i);
			}
		},
		createGameArray(numRandomRequests, randomRequests, paydayRequest, numSpecialRequests, numReturnersForLevel, level) {
			// (number randoms to include for the level, random request data in WP, payday request for the level if
			// there is one, number specials to include for the level, number of returners, level)
			// Get specials for the level
			let specialsArray = [];
			if (numSpecialRequests !== 0) {
				specialsArray = this.allSpecialRequests.splice(0, numSpecialRequests);
				// replace person post ID with person data
				for (let i = 0; i < specialsArray.length; i += 1) {
					if (specialsArray[i].person.toString().length < 5) { // if person assigned
						specialsArray[i].person = this.$store.getters.getPersonByID(specialsArray[i].person);
					}
				}
			}
			// subtract 2 from level 1 total to account for specified Question1 and Question2
			const newNumRandomRequests = level === 0 ? (numRandomRequests - 2) : numRandomRequests;
			// Get random randoms for the level
			const randomArray = this.randomValues(randomRequests, newNumRandomRequests);
			// if level 1, get the specified Question 1 and Question 2
			let randomQuestion1 = null;
			let randomQuestion2 = null;
			if (level === 0) {
				const question1 = JSON.parse(JSON.stringify(this.$store.getters.getRequestsByTypeAndLevelAndOrder(1, "Random", 1)));
				randomQuestion1 = this.randomValue(question1);
				const question2 = JSON.parse(JSON.stringify(this.$store.getters.getRequestsByTypeAndLevelAndOrder(1, "Random", 2)));
				randomQuestion2 = this.randomValue(question2);
				randomArray.unshift(randomQuestion1, randomQuestion2);
			}
			let numReturners = numReturnersForLevel;
			for (let i = 0; i < randomArray.length; i += 1) {
				// pull the next random person from the shuffled people array
				randomArray[i].person = this.peopleForRandoms[this.peopleNum];
				this.peopleNum += 1;
				// put aside returners for building future levels
				if (numReturners > 0) {
					randomArray[i].is_returner = true;
					this.returnerArray.push(randomArray[i]);
					numReturners -= 1;
				}
			}
			// add Returners from returners array to their following level's randoms array
			for (let i = 0; i < this.returnerArray.length; i += 1) {
				if (this.returnerArray[i].game_level === level) {
					if (!this.returnerEmailAssigned) {
						this.returnerArray[i].follow_up_email = true;
						this.returnerArray[i].special_email = 675;
						this.returnerEmailAssigned = true;
					}
					randomArray.push(this.returnerArray[i]);
				}
			}
			// join random and special level requests
			let levelArray = [];
			levelArray = randomArray.concat(specialsArray);
			// PAYDAYS
			// if there's a payday request in this level
			if (paydayRequest.length > 0) {
				// if not set already, select person for payday requests
				if (this.$store.state.paydayPerson === null) {
					// pull the next random person from the shuffled people array
					this.paydayPerson = this.peopleForRandoms[this.peopleNum];
					this.peopleNum += 1;
					this.$store.commit('setPaydayPerson', this.paydayPerson);
				}
				const tempPaydayRequest = paydayRequest[0];
				tempPaydayRequest.person = this.paydayPerson;
				// add the payday request to level array
				levelArray.push(tempPaydayRequest);
			}
			// after specials & paydays are added,
			// if level 1, cut off first 2, shuffle remaining, then add first 2 back
			if (level === 0) {
				const temp1 = levelArray[0];
				const temp2 = levelArray[1];
				levelArray = levelArray.slice(2);
				levelArray = this.shuffled(levelArray);
				levelArray.unshift(temp1, temp2);
			} else { // else just shuffle requests in level
				levelArray = this.shuffled(levelArray);
			}
			// move last request of the level to the front if it is a request with an email
			if (level !== 0) {
				while (levelArray[levelArray.length - 1].follow_up_email === true) {
					const lastWithEmail = levelArray.pop();
					levelArray.unshift(lastWithEmail);
					if (levelArray[levelArray.length - 1].follow_up_email === false) {
						break;
					}
				}
			}
			this.$store.commit('buildGameArray', levelArray);
		},
	},
	mounted() {
		this.setGameStructure();
	},
	watch: {},
};
</script>

<style lang="scss" scoped>
	@import '../../assets/styles/utilities/**/*.scss';
	.custom-enter-active,
	.custom-leave-active {
		transition: opacity 1s linear 1s;
	}
	.custom-enter-to, .custom-leave{
		opacity: 1;
	}
	.custom-enter,
	.custom-leave-to {
		opacity: 1;
	}
	.component-container{
		width: 100%;
		height: 100%;
		position: absolute;
		display: inline-block;
		top: 0;
		left: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/Game.vue